import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_BUSINESS_MIN_HOUR = 6;
const DEFAULT_BUSINESS_MAX_HOUR = 18;
const DEFAULT_MIN_DAYS_AHEAD = 4;

interface InitialState {
  notification: {
    show: boolean;
    message: string | null;
    type: "error" | "success" | "info" | "warning" | null;
  };
  initialListFetched: boolean;
  appSettings: {
    data: any;
    loading: boolean | null;
  };
}

const initialState: InitialState = {
  notification: {
    show: false,
    message: "",
    type: null,
  },
  initialListFetched: false,
  appSettings: {
    data: {
      businessHours: {
        minHour: DEFAULT_BUSINESS_MIN_HOUR,
        maxHour: DEFAULT_BUSINESS_MAX_HOUR,
      },
      minDaysAhead: DEFAULT_MIN_DAYS_AHEAD,
      allowWeekends: false,
    },
    loading: null,
  },
};

const UI = createSlice({
  name: "UI",
  initialState,
  reducers: {
    setInitialListFetched: (state, action) => {
      state.initialListFetched = action.payload;
    },
    showNotification: (state, action) => {
      state.notification = {
        ...state.notification,
        show: true,
        message: action.payload.message,
        type: action.payload.type,
      };
    },
    hideNotification: (state) => {
      state.notification = {
        ...state.notification,
        show: false,
        message: "",
        type: null,
      };
    },
    setAppSettingsLoading: (state, action) => {
      state.appSettings.loading = action.payload;
    },
    setAppSettings: (state, action) => {
      state.appSettings.data = action.payload;
    },
  },
});

export const {
  showNotification,
  hideNotification,
  setInitialListFetched,
  setAppSettings,
  setAppSettingsLoading,
} = UI.actions;

export default UI.reducer;
